import {get} from "lodash"

import {
  DISABLED,
  READY_TO_LAUNCH,
  SAVED_AS_DRAFT,
  LAUNCHED,
  STOPPED,
  ARCHIVED,
  FINISHED,
  IN_PROGRESS
} from "@irati/insights/constants/schedule"

import {isScheduleEnabled as isCycleEnabled, hasScheduleRunAtLeastOnce as hasCycleRunAtLeastOnce} from "./schedule"

const helper = {}

const STATUS_PROPERTY = "status"
const LAST_TRIGGERED_AT_PROPERTY = "lastTriggeredAt"
const VALIDATION_ERRORS = "validationErrors"

helper.isCycleDisabled = (cycle) => {
  return get(cycle, STATUS_PROPERTY) === DISABLED
}

helper.isCycleArchived = (cycle) => {
  return get(cycle, STATUS_PROPERTY) === ARCHIVED
}

helper.isCycleFinishedOrStopped = (cycle) => {
  return get(cycle, STATUS_PROPERTY) === FINISHED || (isCycleDisabled(cycle) && hasCycleRunAtLeastOnce(cycle))
}

helper.hasValidationErrors = (cycle) => {
  return (get(cycle, VALIDATION_ERRORS) || []).length > 0
}

helper.hasCycleRunAtLeastOnce = (schedule) => {
  return !!get(schedule, LAST_TRIGGERED_AT_PROPERTY)
}

helper.isCycleReadyToLaunch = (cycle) => {
  return isCycleDisabled(cycle) && !hasValidationErrors(cycle) && !hasCycleRunAtLeastOnce(cycle)
}

helper.getCycleValidationStatus = (cycle) => {
  if (isCycleFinishedOrStopped(cycle)) {
    return STOPPED
  } else if (isCycleArchived(cycle)) {
    return ARCHIVED
  } else if (isCycleEnabled(cycle)) {
    return hasCycleRunAtLeastOnce(cycle) ? IN_PROGRESS : LAUNCHED
  } else if (isCycleReadyToLaunch(cycle)) {
    return READY_TO_LAUNCH
  }
  return SAVED_AS_DRAFT
}

export const isCycleFinishedOrStopped = helper.isCycleFinishedOrStopped
export const isCycleDisabled = helper.isCycleDisabled
export const isCycleArchived = helper.isCycleArchived
export const getCycleValidationStatus = helper.getCycleValidationStatus
export const hasValidationErrors = helper.hasValidationErrors
export const isCycleReadyToLaunch = helper.isCycleReadyToLaunch

export default helper
